import { Transition } from "@uirouter/react";
import { MenuRoute } from "../../components/menu";
import { EnterOTPPage } from "./2fa";
import { ShowQRCodePage } from "./2fa/show-qr";
import { BaseLogin } from "./base";
import { EmailVerificationPage } from "./email-verification";
import { ForgotPasswordPage } from "./forgot-password";
import { LoginPage } from "./login";
// import { RegisterPage } from "./register";
// import { RegisterMerchantPage } from "./register/business";
import { RegisterIndividualPage } from "./register/individual";
import { ResetPasswordPage } from "./reset-password";
const names = {
  LOGIN: "login.login",
  TwoFA_index: "login.2fa",
  TwoFA_qr: "login.2fa_qr",
  FORGOT_PASSWORD: "login.forgot-password",
  REGISTER: "login.register",
  REGISTER_INDIVIDUAL: "login.register-individual",
  REGISTER_BUSINESS: "login.register-business",
  RESET_PASSWORD: "login.reset",
  EMAIL_VERIFICATION: "login.email-verification",
};

const states: MenuRoute[] = [
  {
    name: "login",
    abstract: true,
    component: BaseLogin,
    data: {
      title: "login",
      unauthed: true,
    },
  },
  {
    name: names.LOGIN,
    url: "/login",
    component: LoginPage,
    data: {
      title: "login",
    },
  },
  {
    name: names.TwoFA_index,
    url: "/2fa",
    component: EnterOTPPage,
    data: {
      title: "enter-one-time-password",
      landing: false,
    },
  },
  {
    name: names.TwoFA_qr,
    url: "/2fa/qr",
    component: ShowQRCodePage,
    data: {
      title: "two-factor-authentication",
      landing: false,
    },
  },
  {
    name: names.FORGOT_PASSWORD,
    url: "/forgot-password",
    component: ForgotPasswordPage,
    data: {
      title: "forgot-password",
    },
  },
  // {
  //   name: names.REGISTER_INDIVIDUAL,
  //   url: "/register/individual",
  //   component: RegisterIndividualPage,
  //   data: {
  //     title: "sign-up",
  //   },
  // },
  // {
  //   name: names.REGISTER_BUSINESS,
  //   url: "/register/business",
  //   component: RegisterMerchantPage,
  //   data: {
  //     title: "sign-up",
  //   },
  // },
  {
    name: names.REGISTER,
    url: "/register",
    component: RegisterIndividualPage,
    data: {
      title: "sign-up",
    },
  },
  {
    name: names.RESET_PASSWORD,
    url: "/reset-password/:token",
    component: ResetPasswordPage,
    data: {
      title: "reset-password",
    },
    params: {
      token: {
        type: "string",
      },
      newPass: {
        type: "bool",
      },
    },
    resolve: [
      {
        token: "token",
        policy: { when: "EAGER" },
        deps: [Transition],
        resolveFn: (trans: Transition) => trans.params().token,
      },
      {
        token: "newPass",
        policy: { when: "EAGER" },
        deps: [Transition],
        resolveFn: (trans: Transition) => trans.params().newPass,
      },
    ],
  },
  {
    name: names.EMAIL_VERIFICATION,
    url: "/email-verification/:token?shouldChangePassword",
    component: EmailVerificationPage,
    data: {
      title: "verify-your-email",
    },
    params: {
      token: {
        type: "string",
      },
      shouldChangePassword: {
        type: "string",
      },
    },
    resolve: [
      {
        token: "token",
        policy: { when: "EAGER" },
        deps: [Transition],
        resolveFn: (trans: Transition) => trans.params().token,
      },
      {
        token: "shouldChangePassword",
        policy: { when: "EAGER" },
        deps: [Transition],
        resolveFn: (trans: Transition) =>
          trans.params().shouldChangePassword === "true",
      },
    ],
  },
];

export const LoginRoutes = {
  names,
  states,
};
